import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Snackbar,
    Alert,
    CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import MaterialButton from './maker/component/MaterialButton';
import { getUser, updatePlan } from './maker/MakerController';
import LineBreak from './maker/component/LineBreak';
import { httpsCallable } from 'firebase/functions';
import { analyticsManager, functions } from '.';
import { useEffect } from 'react';

function UpgradeDialog(props) {
    const { t } = useTranslation();
    const [showAckUpgraded, setShowAckUpgraded] = useState(null);
    const [upgrading, setUpgrading] = useState(false);    
    const [checkoutSessionId, setCheckoutSessionId] = useState(new URLSearchParams(window.location.search).get("session_id"));
    const [checkoutSessionChecked, setCheckoutSessionChecked] = useState(false);
    const [showAckPlanUpdating, setShowAckPlanUpdating] = useState(false);

    const features = [
        {
            name: t('GoogleSync'),
            free: t('No'),
            premium: t('Yes'),
            //premiumPlus: t('Yes')
        },
        {
            name: t('MenuOptimized'),
            free: t('No'),
            premium: t('Yes'),
            //premiumPlus: t('Yes')
        },
        {
            name: t('MaxRestaurants'),
            free: '1',
            premium: '3',/*premium: '1',*/
            //premiumPlus: '3'
        },        
        {
            name: t('MaxStories'),
            free: '1',
            premium: '10',/*premium: '3',*/
            //premiumPlus: '10'
        },    
        {
            name: "",
            free: t('Free'),
            premium: t('PremiumPrice'),
            //premiumPlus: t('PremiumPlusPrice')
        },     
    ];

    function showAckUpgradedSnack(){
        if (showAckUpgraded){            
            return (
                <Snackbar open={showAckUpgraded} autoHideDuration={4000} onClose={()=>setShowAckUpgraded(null)} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                    <Alert onClose={()=>setShowAckUpgraded(null)} severity="success" sx={{ width: '100%' }}>     
                    {
                        showAckUpgraded === "premium" ? t('AckUpgraded') : (showAckUpgraded === "plus" ? t('AckUpgradedPlus') : t('AckDowngraded'))
                    }
                    </Alert>
                </Snackbar>
            );
        }
        else return null;
    }    

    useEffect(() => {
        // validating the stripe checkout after the redirect to update the plan
        if (checkoutSessionId && !checkoutSessionChecked && props.user) {
            refreshPlan(checkoutSessionId);
            setCheckoutSessionId(null);
            setCheckoutSessionChecked(true);
        }
        // for some reason the checkout validation after payment redirect has not been done, we refresh the plan            
        else if (!checkoutSessionId && !checkoutSessionChecked && props.user && props.user.pendingCheckoutSessionId){                
            refreshPlan(props.user.pendingCheckoutSessionId);   
            setCheckoutSessionChecked(true);         
        }
    }, [checkoutSessionId, props.user]);

    function refreshPlan(sessionId){        
        setShowAckPlanUpdating(true);
        const validateCheckout = httpsCallable(functions, "validateCheckout");
        validateCheckout({
            "pendingCheckoutSessionId": sessionId
        })
            .then((result)=> props.onUpgrade(result.data.updatedToPremium))
            .then(()=>{
                getUser(props.uid)
                    .then((uprealityUser) => {
                        props.setUser(uprealityUser);                        
                    })
                    .then(() => {
                        setShowAckPlanUpdating(false);
                    });
            });
    }

    function showAckPlanUpdatingSnack(){
        if (showAckPlanUpdating){
            return (
                <Snackbar open={showAckPlanUpdating} autoHideDuration={6000} onClose={()=>setShowAckPlanUpdating(false)} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                    <Alert onClose={()=>setShowAckPlanUpdating(false)} severity="success">     
                    {t('PlanUpdating')}
                    </Alert>
                </Snackbar>
            );
        }
        else return null;
    }

    if (props.user){

        return (
            <>
                <Dialog
                    open={props.open}
                    onClose={()=>{if (!upgrading) props.onClose();}}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>                        
                        <span style={{fontSize: 34, marginBottom: 12, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{t('ChooseYourPlan')}</span>                            
                        <span style={{fontSize: 16, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{t('UpgradeToPremium')}</span>                            
                    </DialogTitle>
                    
                    <DialogContent>
                        <TableContainer component={Paper} elevation={0}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{}}>{t('Feature')}</TableCell>
                                        <TableCell align="center">
                                            <Box sx={{ p: 2, bgcolor: 'primary.light', color: 'white', borderRadius: 1, }}>
                                                {t('Free')}
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Box sx={{ p: 2, bgcolor: 'secondary.main', color: 'white', borderRadius: 1, }}>
                                                {t('Premium')}
                                            </Box>
                                        </TableCell>
                                        {/*<TableCell align="center">
                                            <Box sx={{ p: 2, bgcolor: 'warning.dark', color: 'white', borderRadius: 1, }}>
                                                {t('PremiumPlus')}
                                            </Box>
                                        </TableCell>*/}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {features.map((feature, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row" sx={{ border: (feature.name === "" ? 'none' : ''), }}>
                                                {feature.name}
                                            </TableCell>
                                            <TableCell align="center" sx={{ border: (feature.name === "" ? 'none' : '') }}>
                                                <Typography variant="body2">
                                                    {feature.free}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center" sx={{ border: (feature.name === "" ? 'none' : '') }}>
                                                <Typography variant="body2" color="secondary">
                                                    {feature.premium}
                                                </Typography>
                                            </TableCell>
                                            {/*<TableCell align="center" sx={{ border: (feature.name === "" ? 'none' : '') }}>
                                                <Typography variant="body2" color="warning.dark">
                                                    {feature.premiumPlus}
                                                </Typography>
                                            </TableCell>*/}
                                        </TableRow>
                                    ))}
                                    <TableRow key={99}>
                                            <TableCell sx={{ border: 'none'}} component="th" scope="row">
                                                
                                            </TableCell>
                                            <TableCell sx={{ border: 'none', verticalAlign: 'bottom'}} align="center">
                                                <Typography variant="body2">
                                                    <LineBreak/>
                                                    {!upgrading && <MaterialButton
                                                        style="text"
                                                        onClick={()=>{                                                                                            
                                                            if (props.upgradeToFreeOverPremium){                                            
                                                                setUpgrading("free");                                        
                                                                updatePlan(props.uid, false)                                                                                                                                    
                                                                    .then(() => props.onUpgrade(false)) 
                                                                    .then(()=>{
                                                                        getUser(props.uid)
                                                                            .then((uprealityUser) => {
                                                                                props.setUser(uprealityUser);                        
                                                                            });
                                                                    }) 
                                                                    .then(() => {analyticsManager.logDowngradeFreeTag();}) 
                                                                    .then(() => props.onClose()) 
                                                                    .then(() => {setShowAckUpgraded("free");})
                                                                    .catch((error) => {})
                                                                    .finally(() => setUpgrading(false));      
                                                            }
                                                            else {
                                                                analyticsManager.logStayFreeTag();
                                                                props.onClose();
                                                            }
                                                        }}
                                                        value={props.upgradeToFreeOverPremium ? t('Downgrade') : (props.trialRunning ? t('ContinueMyTry') : t('StayFree'))}
                                                    />
                                                }
                                                </Typography>
                                                {upgrading === "free" && <CircularProgress sx={{color: '#2FC4B5', }}/>}
                                            </TableCell>
                                            <TableCell sx={{ border: 'none', verticalAlign: 'bottom'}} align="center">
                                                <Typography variant="body2" color="secondary">
                                                {!upgrading && <MaterialButton
                                                    style={props.upgradeToFreeOverPremium ? (props.user.premium === "premium" && ! props.promotePlus ? "filled" : "outlined-tonal") : (props.user.premium === "plus" ? "outlined-tonal" : "filled")}
                                                    onClick={()=>{
                                                        if (props.upgradeToFreeOverPremium && props.user.premium === "premium"){
                                                            analyticsManager.logStayPremiumTag();
                                                            props.onClose();
                                                        }
                                                        else {
                                                            setUpgrading("premium");
                                                            if (!props.user.subscriptionId){
                                                                const createStripeCheckout = httpsCallable(functions, "createCheckout");
                                                                const createStripeCheckoutParams = {
                                                                    "lookup_key": "premium", 
                                                                    "success": props.successRedirectUrl, 
                                                                    "cancel": props.cancelRedirectUrl,                                                                 
                                                                };
                                                                if (props.user.stripeCustomerId){
                                                                    createStripeCheckoutParams.stripeCustomerId = props.user.stripeCustomerId;
                                                                }
                                                                analyticsManager.logUpgradePremiumTag();
                                                                createStripeCheckout(createStripeCheckoutParams)
                                                                    .then((result)=>{window.location = result.data.url;})                                                            
                                                                    .catch((error) => {                                                                                                                                    
                                                                        setUpgrading(false);
                                                                    });
                                                            } else {
                                                                const updatePremiumPlan = httpsCallable(functions, "updateSubscription");
                                                                updatePremiumPlan({
                                                                    "resumePlan": props.user.premiumEnd || ((props.user.premium === "premium" && !props.user.premiumStart) ? true : false),
                                                                    "currentPlan": props.user.premium,
                                                                    "premiumPlan": "premium",
                                                                    "subscriptionId": props.user.subscriptionId,})
                                                                    .then((result)=> props.onUpgrade(result.data.updated))                                                                                                                                  
                                                                    .then(()=>{
                                                                        getUser(props.uid)
                                                                            .then((uprealityUser) => {
                                                                                props.setUser(uprealityUser);                        
                                                                            });
                                                                    })  
                                                                    .then(() => {analyticsManager.logDowngradePremiumTag();})       
                                                                    .then(() => props.onClose())    
                                                                    .then(() => {setShowAckUpgraded("premium");})
                                                                    .catch((error) => {})
                                                                    .finally(() => setUpgrading(false));
                                                                    
                                                            } 
                                                        }
                                                    }}
                                                    value={props.upgradeToFreeOverPremium ? (props.user.premium === "premium" ? t('StayPremium') : t('UpgradeNow')) : ( props.user.premium === "plus" || /*props.trialRunning &&*/ !props.cancelingPremium && !(props.user.subscriptionId && !props.user.premiumStart) ? t('UpgradeNow') : t('TakePremiumAgain'))}
                                                    />
                                                }
                                                {upgrading === "premium" && <CircularProgress sx={{color: '#2FC4B5', }}/>}
                                                </Typography>
                                            </TableCell>
                                            {/*<TableCell sx={{ border: 'none', verticalAlign: 'bottom'}} align="center">                                                
                                                {!upgrading && <MaterialButton
                                                    style={props.upgradeToFreeOverPremium ? (props.user.premium === "plus" || props.promotePlus ? "filled" : "outlined-tonal") : (props.user.premium === "premium" || !props.cancelingPremium ? "outlined-tonal" : "filled")}
                                                    onClick={()=>{
                                                        if (props.upgradeToFreeOverPremium && props.user.premium === "plus"){
                                                            analyticsManager.logStayPlusTag();
                                                            props.onClose();
                                                        }
                                                        else {
                                                            setUpgrading("plus");   
                                                            if (!props.user.subscriptionId){                                     
                                                                const createStripeCheckout = httpsCallable(functions, "createCheckout");
                                                                const createStripeCheckoutParams = {
                                                                    "lookup_key": "plus", 
                                                                    "success": props.successRedirectUrl, 
                                                                    "cancel": props.cancelRedirectUrl,                                                                 
                                                                };
                                                                if (props.user.stripeCustomerId){
                                                                    createStripeCheckoutParams.stripeCustomerId = props.user.stripeCustomerId;
                                                                }
                                                                analyticsManager.logUpgradePlusTag();
                                                                createStripeCheckout(createStripeCheckoutParams)
                                                                    .then((result)=>{window.location = result.data.url;})                                                            
                                                                    .catch((error) => {                                                                                                                                    
                                                                        setUpgrading(false);
                                                                    });
                                                            } else {
                                                                const updatePremiumPlan = httpsCallable(functions, "updateSubscription");
                                                                updatePremiumPlan({
                                                                    "resumePlan": props.user.premiumEnd || ((props.user.premium === "plus" && !props.user.premiumStart) ? true : false),
                                                                    "currentPlan": props.user.premium,
                                                                    "premiumPlan": "plus",
                                                                    "subscriptionId": props.user.subscriptionId,})
                                                                    .then((result)=> props.onUpgrade(result.data.updated))                                                                                                                                  
                                                                    .then(()=>{
                                                                        getUser(props.uid)
                                                                            .then((uprealityUser) => {
                                                                                props.setUser(uprealityUser);                        
                                                                            });
                                                                    })      
                                                                    .then(() => {analyticsManager.logUpgradePremiumPlusTag();})
                                                                    .then(() => props.onClose())
                                                                    .then(() => {setShowAckUpgraded("plus");})
                                                                    .catch((error) => {})
                                                                    .finally(() => setUpgrading(false));
                                                                    
                                                            }                                                                  
                                                        }
                                                    }}
                                                    value={props.upgradeToFreeOverPremium ? (props.user.premium === "plus" ? t('StayPremiumPlus') : t('UpgradeNowPlus')) : ( props.user.premium === "premium" || props.trialRunning && !props.cancelingPremium && !(props.user.subscriptionId && !props.user.premiumStart) ? t('UpgradeNowPlus') : t('TakePremiumPlusAgain'))}
                                                />
                                                }
                                                {upgrading === "plus" && <CircularProgress sx={{color: '#2FC4B5', }}/>}                                                
                                            </TableCell>*/}
                                        </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>                    
                    </DialogContent>
                </Dialog>
                {showAckUpgradedSnack()}
                {showAckPlanUpdatingSnack()}
            </>
        );
    }
    else return null;
}

export default UpgradeDialog;